export interface ISendEmailResponse {
    to: string;
    success: boolean;
}
